import React, { Fragment } from "react";
import classNames from "classnames";
import { Field } from "formik";
import TextEditor from "app/react/components/inputs/TextEditor";
import DisableSection from "./components/DisableSection";
import FormField from "../../../formfields/FormField";
import DatePickerField from "../../../datePicker/DatePickerField";
import Checkbox from "../../../checkbox/Checkbox";

const AccommodationsSection = ({ setFieldValue, sectionId, values }) => {
  return (
    <div className="artist-dialog__section">
      <div className="artist-dialog__section-inner">
        <h3>Accomodations</h3>
        <span
          className={classNames([
            "artist-dialog__configure-setup-button",
            "artist-dialog__configure-setup-button--active",
          ])}
        >
          Configure your setup
        </span>
        <div className="artist-dialog__section-inner__content">
          <DisableSection sectionId={sectionId} values={values} />
          <Field
            name={`${sectionId}.name`}
            label="Rename"
            as={FormField}
            disabled={!values.enabled}
          />
          <label>
            Deadline
            <DatePickerField
              value={values.deadline}
              name={`${sectionId}.deadline`}
              onChange={setFieldValue}
              showPopperArrow={false}
              isLeft
              disabled={!values.enabled}
            />
          </label>
          {values.enabled && (
            <Field name={`${sectionId}.description`} label="Intro text">
              {({ field }) => {
                return (
                  <Fragment>
                    <span className={"form-field__label"}>Intro text</span>
                    <TextEditor
                      imageInsertButtonsOverride={[
                        "imageBack",
                        "|",
                        "imageByURL",
                      ]}
                      height={200}
                      onBlur={(e) =>
                        setFieldValue(
                          `${sectionId}.description`,
                          e.target.value
                        )
                      }
                      id={"introText"}
                      value={field.value}
                    />
                  </Fragment>
                );
              }}
            </Field>
          )}
          {!values.enabled && (
            <Field name={`${sectionId}.description`} label="Intro text">
              {({ field }) => {
                return (
                  <Fragment>
                    <span className={"form-field__label"}>Intro text</span>
                    <div style={{ position: "relative", height: 295 }}>
                      <div className="artist-dialog__text-editor--disabled"></div>
                      <TextEditor
                        imageInsertButtonsOverride={[
                          "imageBack",
                          "|",
                          "imageByURL",
                        ]}
                        height={200}
                        id={"introText"}
                        value={field.value}
                      />
                    </div>
                  </Fragment>
                );
              }}
            </Field>
          )}
          <h5 className="artist-dialog__subheader">LIMITS</h5>
          <label>
            <span className={"form-field__label"}>Max. rooms/day</span>
            <Field
              name={`${sectionId}.room_limit`}
              type="number"
              disabled={!values.enabled}
            />
          </label>
          <label>
            <span className={"form-field__label"}>Max. nights</span>
            <Field
              name={`${sectionId}.night_limit`}
              type="number"
              disabled={!values.enabled}
            />
          </label>
          <Field
            name={`${sectionId}.update_bookings`}
            id={`${sectionId}-update_bookings`}
            as={Checkbox}
            label="Update limits for existing bookings"
            disabled={!values.enabled}
          />
          <h5 className="artist-dialog__subheader">ACCOMMODATION REQUESTS</h5>
          <Field
            name={`${sectionId}.create`}
            id={`${sectionId}-create`}
            as={Checkbox}
            label="Allow to select & add accommodations on the production website"
            disabled={!values.enabled}
          />
          <Field
            name={`${sectionId}.requires_approval`}
            id={`${sectionId}-requires_approval`}
            as={Checkbox}
            label="Require promoter approval for reservations created or edited through the production website"
            disabled={!values.enabled}
          />
        </div>
      </div>
    </div>
  );
};

AccommodationsSection.propTypes = {};

export default AccommodationsSection;
